import Vue from 'vue';
import VueTheMask from 'vue-the-mask';
import HtmlParticipantEntryForm from './components/Participants/Form/Default.vue'; //Used for series bookings on front_end
import LoginOrGhost from './components/Users/LoginOrGhost';
import LoginOrSignup from './components/Users/LoginOrSignup/LoginOrSignup.vue';
import ClubSelect from './components/AAA_TO_REFACTOR/ClubSelect';

require('./bootstrap');

window.moment = require('moment-timezone');
window.moment.locale('en-gb');
moment.tz.setDefault('Europe/London');

require('es6-promise').polyfill();
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'; // this appears to be set by default - can it be removed?

try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {
    alert(e);
}

Vue.use(VueTheMask);

new Vue({
    el: '#root',
    components: {HtmlParticipantEntryForm, LoginOrGhost, LoginOrSignup, ClubSelect}
});





// WEBPACK FOOTER //
// ./src/Assets/html_form.js